/**
 * Feature flags.
 *
 * billingEnabled controls chrome only (nav Pro badge, Settings plan card).
 * /pricing is always reachable by URL so checkout can be tested.
 */
function readFlag(globalKey, fallback = false) {
  const raw = globalThis[globalKey]
  if (raw === true) return true
  if (raw === false || raw == null || raw === '') return fallback
  return String(raw).toLowerCase() === 'true'
}

export const billingEnabled = readFlag('__BILLING_ENABLED__', false)
